<script setup>
  import { ref } from "vue";
  import { onClickOutside } from "@vueuse/core";

  const dropdown = ref(null);

  const active = ref(false);
  const alignRight = ref(false);

  onClickOutside((dropdown), () => {
    active.value = false;
  });

  function toggle() {
    active.value = !active.value;
    if (active.value && dropdown.value) {
      const rect = dropdown.value.getBoundingClientRect();
      alignRight.value = rect.left + rect.width / 2 > window.innerWidth / 2;
    }
  }
</script>

<template>
  <div ref="dropdown" class="dropdown" :class="{ 'is-active': active, 'is-right': alignRight }">
    <div class="dropdown-trigger" @click="toggle">
      <slot name="trigger"></slot>
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
